import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import FullScreenCardPage from "./FullScreenCardPage";
import SlideNavigation from "./SlideNavigation";
import WithTeacherTips from "./WithTeacherTips";
import { RemoteSlideProps, Slide } from "./types";

export const DescriptionSlide = (text?: string, img?: string, sentenceStarter?: string): Slide => {
  return {
    remote: ({ next }: RemoteSlideProps) => {
      return (
        <WithTeacherTips>
          <div sx={style}>
            <div sx={cardStyle}>
              {text && <div sx={descriptionStyle}>{text}</div>}

              {img && <img src={img} sx={text === null ? fullImageStyle : imageStyle} alt="Mojo Image" />}
            </div>
            <SlideNavigation onBack={() => next(-1)} onNext={() => next()} />
          </div>
        </WithTeacherTips>
      );
    },
    display: () => {
      return (
        <FullScreenCardPage>
          <div sx={{ backgroundColor: "dt_background_primary", borderRadius: "dt_radius_s", overflow: "hidden" }}>
            {text && <div sx={descriptionDisplayStyle}>{text} </div>}
            {sentenceStarter && (
              <div sx={{ fontSize: "32px", textAlign: "center", margin: "dt_xxl" }}> {sentenceStarter}</div>
            )}
            {img && (
              <div>
                <img src={img} sx={text === null ? fullImageDisplayStyle : imageDisplayStyle} alt="Mojo Image" />
              </div>
            )}
          </div>
        </FullScreenCardPage>
      );
    },
  };
};

const style: ThemeUIStyleObject = {
  padding: RAW_cssValue("12px"),
  maxWidth: "500px",
  marginLeft: "auto",
  marginRight: "auto",
};

const cardStyle: ThemeUIStyleObject = {
  borderRadius: "dt_radius_s",
  backgroundColor: "dt_background_primary",
  border: `dt_disabled`,
  textAlign: "center",
  overflow: "hidden" as const,
  padding: RAW_cssValue("26px 26px"),
  marginBottom: RAW_cssValue("14px"),
  width: "100%",
};

const descriptionStyle: ThemeUIStyleObject = {
  fontSize: "24px",
  lineHeight: "1.3",
  fontWeight: 600,
  textAlign: "center",
  marginBottom: RAW_cssValue("14px"),
  color: "dt_content_primary",
};

const descriptionDisplayStyle: ThemeUIStyleObject = {
  fontSize: "38px",
  lineHeight: "1.3",
  margin: RAW_cssValue("45px 82px 45px"),
  fontWeight: 600,
  textAlign: "center",
  color: "dt_content_primary",
};

const imageStyle: ThemeUIStyleObject = {
  display: "inline-block",
  width: "100%",
  height: "auto",
  maxHeight: "300px",
};

const imageDisplayStyle: ThemeUIStyleObject = {
  display: "inline-block",
  margin: RAW_cssValue("0px 40px 40px"),
  width: "calc(100% - 80px)",
  height: "calc(100% - 40px)",
  maxHeight: "325px",
  objectFit: "contain",
};

const fullImageStyle: ThemeUIStyleObject = {
  display: "inline-block",
  width: "100%",
  height: "100%",
};

const fullImageDisplayStyle: ThemeUIStyleObject = {
  display: "block",
  margin: "auto",
  width: "100%",
  height: "100%",
};
